import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyCommunicationRecipientMetierApiService } from './company-communication-recipient-metier-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCommunicationRecipientMetierApiService extends GeneratedCompanyCommunicationRecipientMetierApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
